import ActiveSessionCard from "./ActiveSessionCard";

export default ActiveSessionCard;